import { ACCIONES_CRUD } from '../utils';

export default {
  props: {
    nombreRecurso: {
      type: String,
      default: 'Ítem',
    },
  },
  computed: {
    titulo() {
      const nombreRecurso = this.nombreRecurso.toUpperCase();

      return this.form?.id ? `EDITAR ${nombreRecurso}` : `REGISTRAR ${nombreRecurso}`;
    },
  },
  data() {
    return {
      visible: false,
      form: this.generarObjetoFormRegistrar(),
      errores: [],
      enviando: false,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      alert('Sobre escribir "generarObjetoFormRegistrar" en el componente');

      return {};
    },
    generarObjetoFormEditar() {
      alert('Sobre escribir "generarObjetoFormEditar" en el componente');

      return {};
    },
    abrirMixin(accion, data = null) {
      if (accion == ACCIONES_CRUD.REGISTRAR) {
        this.form = this.generarObjetoFormRegistrar();
      }

      if (accion == ACCIONES_CRUD.EDITAR) {
        this.form = this.generarObjetoFormEditar(data);
      }

      this.visible = true;
      this.errores = [];
    },
    cerrar() {
      this.visible = false;
    },
    async registrar() {
      alert('Sobre escribir "registrar" en el componente');
    },
    async editar() {
      alert('Sobre escribir "editar" en el componente');
    },
    validar() {
      if (!this.enviando) {
        this.enviando = true;

        if (this.form?.id) {
          this.editar();
        } else {
          this.registrar();
        }
      }
    },
  },
};
